
function getString(_object)
{
    if (_object === undefined)
        return '';
    else if (_object === null)
        return '';
    else
        return String(_object);
}

function checkArray(_array, obj, start) {
    for (var i = (start || 0), j = _array.length; i < j; i++) {
        if (_array[i] === obj) { return i; }
    }
    return -1;
}

var FirstwebValidation = function (_formClass) {
    this.Formular = $("." + _formClass);
    this.ValidationSummeryIsVisible = false;
    this.Sender = null;
    this.ShowSummery = false;
    this.SummeryBox = null;
    this.SummeryText = '';
    this.IsValid = true;
    this.AllowBlankErrorTextInput = this.Formular.data("validation-blank");
    this.AllowBlankErrorOthers = this.Formular.data("validation-other");
    this.UnknownError = 'unknown error';
    this.ErrorItems = $("#gdfg");
    this.ErrorMessages = [];
    this.ErrorFields = [];
    this.FieldMandatoryClass = 'fieldMandatory';

    this.MarkMandatoryFields = function (_position) {
        _this = this;

        if (this.Items === null)
            this.Items = $("*[validate='true']");

        this.Items.each(function (i) {

            var Item = $(this);
            var displayError = false;
            var errorText = '';

            if (Item.attr("allowBlank") == 'false') {

                if ((Item[0].type == 'text' || Item[0].type == 'password') && (Item[0].tagName == 'INPUT'))
                    _mandatoryText = '<span class="ismandatory" for="' + Item[0].name + '" style="color:#CC0000;" title="' + _this.AllowBlankErrorTextInput + '"> * </span>';
                else
                    _mandatoryText = '<span class="ismandatory" for="' + Item[0].name + '" style="color:#CC0000;" title="' + _this.AllowBlankErrorOthers + '"> * </span>';

                if (_position == 'before')
                    Item.before(_mandatoryText);
                else if (_position == 'css')
                    Item.addClass('fieldMandatory');
                else if (_position == 'style')
                    Item.attr('style', Item.attr('style') + ';border-right:2px solid #cc0000;');
                else
                    Item.after(_mandatoryText);

            }
        });
    };
    this.GetFriendlyName = function (_item) {
        var _friendly = getString(_item.attr('friendly'));
        if (_friendly === '')
            _friendly = $("LABEL[for='" + _item[0].id + "']").text();

        return _friendly;
    },

        this.ShowError = function (_item, _errortext) {
            var _friendly = this.GetFriendlyName(_item);//getString(_item.attr('friendly'));
            if (_friendly !== '')
                _errortext = _friendly + ': ' + _errortext;

            _errorElementId = getString(_item.attr('errorelement'));
            if (_errorElementId !== '')
                $("#" + _errorElementId).show()[0].title = _errortext;

            _item.addClass("error")[0].title = _errortext;
            this.IsValid = false;

            var idx = checkArray(this.ErrorFields, _item[0].id);

            //Hvis feltet allerede findes, opdater fejlbesked
            if (idx > -1) {
                this.ErrorMessages[idx] = _errortext;
            }
            else {	//Ellers tilføj felt
                this.ErrorMessages.push(_errortext);
                this.ErrorFields.push(_item[0].id);
            }
        },

        this.HideError = function (_item) {
            var idx = checkArray(this.ErrorFields, _item[0].id);

            if (idx > -1) {
                this.ErrorFields.splice(idx, 1);
                this.ErrorMessages.splice(idx, 1);
            }
            _errorElementId = getString(_item.attr('errorelement'));
            if (_errorElementId !== '')
                $("#" + _errorElementId).hide()[0].title = '';

            _item.removeClass("error")[0].title = '';
        },

        this.GenerateValidationSummery = function () {
            this.SummeryText = '<div class="row">';
            for (var i = 0; i < this.ErrorMessages.length; i++) {
                this.SummeryText += "<div class='col-md-12 col-sm-12 col-xs-12'><i class='fa fa-exclamation-circle mr-2' aria-hidden='true'></i>" + this.ErrorMessages[i] + "</div>";
            }
            this.SummeryText += '</div>';
        },

        this.ShowValidationSummeryPopup = function () {
            _this = this;
            this.GenerateValidationSummery();
            if (this.SummeryBox === null)
                this.SummeryBox = $("#ValidationSummeryPopup");

            this.SummeryBox.find(".message").html(this.SummeryText);

            this.SummeryBox.click(function () {
                _this.HideValidationSummeryPopup();
            });

            this.SummeryBox
                .fadeIn()
                .css({
                    top: (this.Sender.position().top + 15) + "px",
                    left: (this.Sender.position().left + 15) + "px"
                });
        },

        this.HideValidationSummeryPopup = function () {
            if (this.SummeryBox === null)
                this.SummeryBox = $("#ValidationSummeryPopup");

            this.ClearAllErrorElements();

            this.SummeryBox.find(".message").html('');
            this.SummeryBox.fadeOut();
        },


        this.ShowValidationSummery = function () {
            this.GenerateValidationSummery();

            if (this.SummeryBox === null)
                this.SummeryBox = $("#ValidationSummeryBox");

            this.SummeryBox.find(".message").html(this.SummeryText);

            this.SummeryBox.slideDown();
            this.ValidationSummeryIsVisible = true;
        },

        this.HideValidationSummery = function () {
            if (this.SummeryBox === null)
                this.SummeryBox = $("#ValidationSummeryBox");

            this.SummeryBox.find(".message").html('');
            this.SummeryBox.slideUp();

            this.ValidationSummeryIsVisible = false;
        },

        this.ClearAllErrorElements = function () {
            _this = this;
            this.ErrorItems.each(function (i) {

                var Item = $(this);
                _this.HideError(Item);
            });
            this.ErrorItems.first().focus();
        },

        this.ValidateItem = function (Item) {
            var displayError = false;
            var errorText = '';

            //Allow blank check
            if ((Item.attr("allowBlank") == 'false') && (Item.val() === '')) {
                displayError = true;

                if ((Item[0].type == 'text' || Item[0].type == 'password') && (Item[0].tagName == 'INPUT'))
                    errorText = _this.AllowBlankErrorTextInput;
                else
                    errorText = _this.AllowBlankErrorOthers;
            }
            else {
                //Regular expression validation
                regError = false;
                _regularExpression = getString(Item.attr('regularexpression'));
                if (_regularExpression !== '' && Item.val() !== "") {
                    if(_regularExpression == 'email')
                        _regularExpression = /^([a-zA-Z0-9]+([\.+_-][a-zA-Z0-9]+)*)@(([a-zA-Z0-9]+((\.|[-]{1,2})[a-zA-Z0-9]+)*)\.[a-zA-Z]{2,6})$/;
                    myRegExp = new RegExp(_regularExpression);
                    if (myRegExp.exec(Item.val()) === null) {
                        displayError = true;
                        regError = true;
                    }
                }

                //Function validation
                _validationFunction = getString(Item.attr('validationfunction'));
                if ((!displayError) && (_validationFunction !== '')) {
                    var isFieldValid = false;
                    (function(){
                        var fnName = _validationFunction;
                        var fn = (typeof window !== 'undefined' ? window[fnName] : undefined);
                        if (typeof fn !== 'function') {
                            // Try looking up on globalThis as a fallback
                            try {
                                fn = (typeof globalThis !== 'undefined') ? globalThis[fnName] : undefined;
                            } catch(e) { fn = undefined; }
                        }
                        var _result = false;
                        if (typeof fn === 'function') {
                            _result = fn(Item);
                        } else {
                            // Unknown validation function name -> treat as failure and produce message
                            _result = "Validation function '" + fnName + "' not found";
                        }
                        isFieldValid = _result;
                    })();

                    isFieldValid = String(isFieldValid);
                    if (isFieldValid == 'true') {
                    }
                    else if (isFieldValid == 'false') {
                        displayError = true;
                    }
                    else {
                        displayError = true;
                        errorText = isFieldValid;
                    }
                }

                if (displayError) {
                    if (errorText === '') {
                        if (getString(Item.attr('errordescriptionid')) !== '')
                            (function(){
                                var _descIdRaw = getString(Item.attr('errordescriptionid'));
                                var _descId = _descIdRaw ? _descIdRaw.replace(/^#/, '') : '';
                                var _el = _descId ? document.getElementById(_descId) : null;
                                if (_el) {
                                    var txt = (_el.textContent || _el.innerText || '').trim();
                                    if (txt) { errorText = txt; }
                                }
                            })();
                        else if ((regError) && (getString(Item.attr('errordescription_reg') !== '')))
                            errorText = getString(Item.attr('errordescription_reg'));
                        else if ((!regError) && (getString(Item.attr('errordescription_func') !== '')))
                            errorText = getString(Item.attr('errordescription_func'));

                        if (errorText === '')
                            errorText = _this.UnknownError;
                    }
                }
            }

            if (displayError)
                _this.ShowError(Item, errorText);
            else
                _this.HideError(Item);

        },

        this.Clear = function () {
            _this = this;

            //Clear 
            this.IsValid = true;
            this.ErrorItems = $("#gdfg");
            this.ErrorMessages = [];
            this.ErrorFields = [];

            if (this.Items === null)
                this.Items = $("*[validate='true']");

            this.Items.each(function (i) {
                _this.HideError($(this));
            });

            if (this.ShowSummery) {
                if (!this.IsValid)
                    this.ShowValidationSummery();
                else
                    this.HideValidationSummery();
            }
        },

        this.Validate = function () {
            _this = this;

            //Clear 
            this.IsValid = true;
            this.ErrorItems = $("#gdfg");
            this.ErrorMessages = [];
            this.ErrorFields = [];

            if (this.Items === null)
                this.Items = $("*[validate='true']");

            this.Items.each(function (i) {
                if ($(this).attr('tempdontvalidate') != 'true')
                    _this.ValidateItem($(this));
                else
                    _this.HideError($(this));
            });

            if (this.ShowSummery) {
                if (!this.IsValid)
                    this.ShowValidationSummery();
                else
                    this.HideValidationSummery();
            }
        };

};